/**
 * Amber marks what needs attention soon without being an error (that is red): work that will
 * likely be late, time off, heads-ups to send. Readable in the light and the dark theme.
 */
export const attention = {
  /** An outlined badge or chip. */
  badge:
    'border-amber-500/45 bg-amber-50 text-amber-900 dark:border-amber-400/35 dark:bg-amber-400/10 dark:text-amber-200',
  /** Hover for a chip that is a link or a button. */
  hover: 'hover:bg-amber-100 dark:hover:bg-amber-400/20',
  /** A filled dot with a count. */
  dot: 'bg-amber-500 text-amber-950',
  /** An icon next to plain text. */
  icon: 'text-amber-600 dark:text-amber-400',
} as const

/**
 * Priority chips: rose for high (a tint, so it stays apart from the solid red of overdue), sky
 * for low; normal shows no chip. Readable in the light and the dark theme.
 */
export const priorityTone = {
  high: 'border-rose-400/50 bg-rose-50 text-rose-800 dark:border-rose-400/35 dark:bg-rose-400/10 dark:text-rose-200',
  low: 'border-sky-400/50 bg-sky-50 text-sky-800 dark:border-sky-400/35 dark:bg-sky-400/10 dark:text-sky-200',
} as const
